// Tickable Mail: common texts (en)
export default {
  "mail_menu_setup": "Set up",
  "mail_actions_title": "What do you want to do?",
  "mail_reach_sentence": "Nobody in your audience yet. Buyers are added automatically. | 1 person in your audience, {consent} want your news. | {people} people in your audience, {consent} want your news.",
  "mail_action_news": "Send a newsletter",
  "mail_action_news_text": "Tell everyone who wants your news about your next activity.",
  "mail_action_inbox": "Messages",
  "mail_action_inbox_unread": "1 new message | {n} new messages",
  "mail_action_inbox_text": "Replies from visitors to your mails, in one place.",
  "mail_action_people": "Visitors",
  "mail_action_people_text": "All your customers, what they bought and who wants your news.",
  "mail_system_order_cancelled": "Cancellation",
  "mail_system_order_refunded": "Refund",
  "mail_system_extras_bought": "Extra added",
  "mail_switch_safe": "No worries: nothing changes until you switch something on. And you can always go back.",
  "mail_next_title": "Ready for you",
  "mail_next_all_good": "All running smoothly",
  "mail_next_all_good_text": "Nothing is waiting for you. Your emails go out by themselves.",
  "mail_next_replies": "1 reply is waiting | {n} replies are waiting",
  "mail_next_replies_text": "Visitors replied to an email. They get your answer in their own inbox.",
  "mail_next_to_inbox": "Go to inbox",
  "mail_next_reminder": "Your reminder is ready",
  "mail_next_reminder_text": "Two days before the visit, visitors get everything in one place. It is still off.",
  "mail_next_thanks": "Your thank-you is ready",
  "mail_next_thanks_text": "A thank-you afterwards, only for those who came. It is still off.",
  "mail_next_turn_on": "Turn on",
  "mail_next_look_first": "Look first",
  "mail_next_news": "1 person wants your news | {n} people want your news",
  "mail_next_news_text": "Tell them about your next activity with a newsletter.",
  "mail_next_news_action": "Create newsletter",
  "mail_title": "Audience",
  "mail_overview": "Overview",
  "mail_flows": "Automatic emails",
  "mail_campaigns": "Newsletters",
  "mail_templates": "Designs",
  "mail_contacts": "Visitors",
  "mail_inbox": "Messages",
  "mail_settings": "E-mail settings",
  "settings_mail": "E-mail",
  "mail_settings_to_mail": "Go to Mail →",
  "mail_overview_classic_intro": "Your ticket e-mails still go out in the standard layout. Switch over and make them all yours.",
  "mail_overview_on_intro": "The people who come to your activities, and how you reach them.",
  "mail_switch_what_title": "What you get",
  "mail_benefit_design_title": "Your own e-mails",
  "mail_benefit_design": "Your logo, your colours, your words.",
  "mail_benefit_flows_title": "Automations",
  "mail_benefit_flows": "A reminder before, a thank-you after.",
  "mail_benefit_campaigns_title": "Campaigns",
  "mail_benefit_campaigns": "Tell your visitors about your next event.",
  "mail_benefit_inbox_title": "Inbox",
  "mail_benefit_inbox": "Replies from visitors land right here.",
  "mail_switch_needs_slug": "To switch, your organization needs a web address (slug); your sender address is built on it.",
  "mail_switch_set_slug": "Set your web address",
  "mail_switch_button": "Turn on your own mails",
  "mail_switch_consent_now": "Start asking for consent in your shop",
  "mail_switched": "You've switched over",
  "mail_switched_detail": "Have a look around: your automations are ready, but still off.",
  "mail_switch_failed": "Switching didn't work",
  "mail_to": "To",
  "mail_subject": "Subject",
  "mail_status": "Status",
  "mail_when": "When",
  "mail_status_queued": "Going out soon",
  "mail_status_sending": "Sending",
  "mail_status_sent": "Sent",
  "mail_status_delivered": "Delivered",
  "mail_status_skipped": "Skipped",
  "mail_status_failed": "Failed",
  "mail_status_bounced": "Didn't arrive",
  "mail_status_complained": "Marked as spam",
  "mail_skip_wait_passed": "The moment had already passed",
  "mail_skip_no_consent": "No consent for news e-mail",
  "mail_skip_unsubscribed": "Unsubscribed",
  "mail_skip_bounced": "This address doesn't work",
  "mail_skip_frequency_cap": "A news e-mail already went to this address today",
  "mail_skip_order_gone": "The order no longer exists",
  "mail_skip_order_unpaid": "The order isn't paid",
  "mail_skip_already_paid": "Already paid",
  "mail_skip_refunded": "Refunded",
  "mail_skip_no_discount": "No discount linked to the code block",
  "mail_skip_blocked_content": "Not sent: content held back",
  "mail_system_order_confirmation": "Ticket confirmation",
  "mail_system_voucher": "Voucher",
  "mail_system_reservation_payment": "Reservation payment link",
  "mail_system_signup_confirm": "Signup confirmation",
  "mail_system_waitlist_joined": "On the waitlist",
  "mail_system_waitlist_offer": "A place from the waitlist",
  "mail_system_waitlist_open": "Tickets back for the waitlist",
  "mail_system_manage_code": "Code to change your order",
  "mail_system_manual_html": "Reply from the inbox",
  "notification_type_mail_reply": "New message in your inbox",
  "notification_type_mail_reply_description": "A visitor replied to an e-mail",
  "notification_type_mail_flow": "Notification from an automation",
  "notification_type_mail_flow_description": "An automation with a 'Notify' step wants to tell you something",
  "notification_type_self_service": "Cancellations by visitors",
  "notification_type_self_service_description": "A visitor cancelled themselves, with or without money back. If a refund didn't work, you'll see it here.",
  "notification_type_payout": "Payouts",
  "notification_type_payout_description": "An email for every payout: how much is on its way and when it reaches your bank account",
  "notification_type_organizer_tips": "Tips and reminders from Tickable",
  "notification_type_organizer_tips_description": "A tip that fits how you sell (at most once every two weeks), and reminders like 'sales start soon' and 'almost sold out'",
  "mail_system_cancellation_choice": "Choice after a cancellation",
  "mail_system_order_voucher": "Voucher after a cancellation",
  "mail_overview_people": "Nobody yet. Buyers are added automatically. | 1 visitor | {n} visitors",
  "mail_overview_consent": "nobody wants your news yet | 1 wants your news | {n} want your news",
  "mail_overview_see_all": "See all",
  "mail_overview_groups_hint": "Your next newsletter can go to exactly one of these groups.",
  "mail_overview_waiting": "Waiting for you",
  "mail_overview_replies": "1 reply | {n} replies",
  "mail_overview_reply": "Reply",
  "mail_overview_automatic": "Goes by itself",
  "mail_overview_ticket_mail": "Ticket mail",
  "mail_overview_ticket_mail_when": "Right after buying, always.",
  "mail_overview_look": "View",
  "mail_overview_last_news": "Latest newsletter",
  "mail_overview_preview_caption": "Your own ticket mail, with the logo and colour from your shop",
  "mail_overview_switch_gets": "A reminder before, a thank-you after, and replies that land here.",
  "mail_overview_test_me": "Send me a test first",
}
